var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-data-footer",attrs:{"id":"table-footer"}},[_vm._v(" "+_vm._s(_vm.items ? _vm.items.length : 0)+" "+_vm._s(_vm.items && _vm.items.length === 1 ? _vm.labelSingular : _vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }